"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.grpcMetrics = exports.logGeneralError = exports.logResponseSize = exports.logLatency = exports.logInvalidResponse = exports.logStatusCode = exports.logAttempt = exports.logNonRetryReason = exports.logRetry = void 0;
const grpc_web_1 = require("@improbable-eng/grpc-web");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const GRPC_METRIC_PREFIX = "grpc";
function logRetry(metricsPrefix, path, count) {
    void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.${GRPC_METRIC_PREFIX}.${path}.retry_count_${count}`);
}
exports.logRetry = logRetry;
function logNonRetryReason(metricsPrefix, path, reason) {
    void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.${GRPC_METRIC_PREFIX}.no_retry_reason.${path}.${reason}`);
}
exports.logNonRetryReason = logNonRetryReason;
function logAttempt(metricsPrefix, path) {
    void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.${GRPC_METRIC_PREFIX}.${path}.attempt`);
}
exports.logAttempt = logAttempt;
function logStatusCode(metricsPrefix, path, statusCode) {
    void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.${GRPC_METRIC_PREFIX}.${path}.grpc_code.${statusCode}.${grpc_web_1.grpc.Code[statusCode]}`);
}
exports.logStatusCode = logStatusCode;
function logInvalidResponse(metricsPrefix, path) {
    void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.${GRPC_METRIC_PREFIX}.${path}.invalid_response`);
}
exports.logInvalidResponse = logInvalidResponse;
function logLatency(metricsPrefix, path, latency) {
    graphene_1.default.addTimer({
        metricsName: `${metricsPrefix}.${GRPC_METRIC_PREFIX}.${path}.latency`,
        milliSec: Math.round(latency),
    });
    graphene_1.default.addTimer({
        metricsName: `${metricsPrefix}.${GRPC_METRIC_PREFIX}.grpc_latency`,
        milliSec: Math.round(latency),
        dimensions: {
            api: path,
        },
    });
}
exports.logLatency = logLatency;
function logResponseSize(metricsPrefix, path, size) {
    void (0, web_graphene_reporting_1.reportHistogram)(`${metricsPrefix}.${GRPC_METRIC_PREFIX}.${path}.response_size`, Math.round(size));
}
exports.logResponseSize = logResponseSize;
function logGeneralError(metricsPrefix, path) {
    void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.${GRPC_METRIC_PREFIX}.${path}.error`);
}
exports.logGeneralError = logGeneralError;
exports.grpcMetrics = {
    logAttempt,
    logStatusCode,
    logInvalidResponse,
    logLatency,
    logGeneralError,
    logResponseSize,
    logRetry,
    logNonRetryReason,
};
//# sourceMappingURL=metrics.js.map